






import Vue, { PropType } from 'vue'
import Component from 'vue-class-component'
import { Marketplace } from './enums/marketplace'

type Logo = Marketplace | 'messaging'

const MarketplaceLogoProps = Vue.extend({
  props: {
    size: {
      type: String || Number,
      validator: size => {
        try {
          parseInt(size as string)
          return true
        } catch {
          return false
        }
      },
    },
    marketplace: {
      required: true,
      type: String as PropType<Logo>,
      validator: marketplace => {
        const possibleValues = (Object.values(Marketplace) as Logo[]).concat('messaging')
        return possibleValues.includes(marketplace)
      }
    },
  },
})

@Component
export default class MarketplaceLogo extends MarketplaceLogoProps {
  public get brandLogoPath (): string {
      switch (this.marketplace) {
        case 'messaging':
        case Marketplace.TESTSITE:
          return 'logo_parrot_color.png'
        case Marketplace.LEBONCOIN:
        case Marketplace.KUFAR:
        case Marketplace.SEGUNDAMANOMX:
          return `brand-logos/${this.marketplace.toLowerCase()}.svg`
        default:
          return `brand-logos/${this.marketplace.toLowerCase()}.png`
      }
    }
}

